import { Cross2Icon } from "@radix-ui/react-icons";
import { Box, Button, Flex, Text } from "@radix-ui/themes";
import { Control, Controller, FieldErrors, FieldValues, Path } from "react-hook-form";
import Select from "react-select";
import styles from "./SelectComponent.module.scss";

interface SelectProps<T extends FieldValues> {
  name: Path<T>;
  label: string;
  control: Control<T>;
  errors: FieldErrors<T>;
  style?: any;
  fieldProps?: any;
  options?: { value: string; label: string }[];
  itemsLoading?: boolean;
  itemsError?: boolean;
  onSelect?: (value: string[]) => void;
  composedName?: { parent: any; prop: any };
  required?: boolean;
  activateSelectAllButton?: boolean;
  setValue?: any;
}

const MultiSelectComponent = <T extends FieldValues>({
  name,
  label,
  control,
  errors,
  style,
  fieldProps,
  options,
  onSelect,
  composedName,
  itemsError,
  itemsLoading,
  required,
  activateSelectAllButton,
  setValue,
}: SelectProps<T>) => {
  const castedErrors = errors as Record<string, any>;

  const composedError =
    composedName && composedName.parent && composedName.prop
      ? castedErrors?.[composedName.parent]?.[composedName.prop]
      : undefined;

  const handleOnClickSelectAll = (event: any) => {
    event.preventDefault();
    if (options && options.length > 0) {
      const allValues = options.map(option => option.value);
      if (setValue) {
        setValue(name, allValues as any, { shouldValidate: true });
        if (onSelect) onSelect(allValues);
      }
    }
  };

  return (
    <Box {...style}>

      <Text as="label" size="2" className={styles.label}>
        <span>
          {label} {required && <span style={{ color: "red" }}>*</span>}
        </span>
      </Text>

      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            <div className={styles.selectContainer}>
              <Select
                label={label}
                isMulti
                options={options}
                isLoading={itemsLoading}
                isDisabled={itemsError || fieldProps?.disabled}
                value={options?.filter((opt) => field.value?.includes(opt.value)) || []}
                onChange={(selectedOptions: any) => {
                  const values = selectedOptions.map((option: any) => option.value);
                  field.onChange(values);
                  if (onSelect) onSelect(values);
                }}
                classNamePrefix="react-select"
                {...fieldProps}
                placeholder="Selecionar..."
                menuPortalTarget={document.body}
                 styles={{
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  }}
              />
              {field.value?.length > 0 && !fieldProps?.disabled && (
                <Button
                  variant="ghost"
                  size="1"
                  onClick={() => field.onChange([])}
                  className={styles.clearButton}
                  style={{ margin: "4px 0px 0px 0px" }}
                >
                  <Cross2Icon />
                </Button>
              )}
              {!(field.value?.length > 0 && !fieldProps?.disabled) && activateSelectAllButton && (
                <Button type='button' variant="ghost" onClick={handleOnClickSelectAll} style={{ margin: "4px 0px 0px 0px" }}>
                  Selecionar todos
                </Button>
              )}
            </div>
            {composedError ? (
              <Text color="red" size="1">
                {composedError.message as string}
              </Text>
            ) : (
              errors?.[name] && (
                <Text color="red" size="1">
                  {errors?.[name]?.message as string}
                </Text>
              )
            )}
          </>
        )}
      />
    </Box >
  );
};

export default MultiSelectComponent;